import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";
import { getGradeAPI } from "../../../assignmentAPI";

import { useTTS } from "../../../../../hooks/useTTS";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import CommonPage from "../../common/CommonPage";
import ChoiceTestPage from "./ChoiceExamPage";
import SubjectiveExamPage from "./SubjectiveExamPage";

const VocaTestPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const { speak, stopSpeaking } = useTTS();

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [userInput, setUserInput] = useState("");

  const currentPage = pageList[currentIndex] || { type: "", data: {} };

  const handleNextPage = () => {
    if (currentIndex + 1 < pageList.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      if (pageList.every((page) => page.isSubmitted)) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { answer: pageList, is_finished: true },
            })
          );
        }
        alert("테스트 완료했습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleSubmit = async () => {
    let isCorrect;
    if (currentPage.type === "engkor") {
      const response = await getGradeAPI({
        type: "vocabulary",
        data: {
          question: currentPage.text,
          input: userInput,
          answer: currentPage.answer,
        },
      });
      isCorrect = response.is_correct === 1;
    } else {
      isCorrect = userInput.toLowerCase() === currentPage.answer.toLowerCase();
    }

    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          isCorrect,
          input: userInput,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    speak({ text: currentPage.word });

    setOverlayVisible(true);
    setTimeout(() => {
      if (isCorrect) {
        setTimeout(() => {
          if (currentIndex + 1 < pageList.length) {
            setCurrentIndex(currentIndex + 1);
          }
        }, 200);
      }
      setOverlayVisible(false);
      setUserInput(currentPage.answer);
    }, 600);
  };

  useEffect(() => {
    if (currentPage.isSubmitted) {
      setUserInput(currentPage.answer);
    } else {
      setUserInput(currentPage.input || "");
    }
    stopSpeaking();
  }, [currentIndex]);

  useEffect(() => {
    if (pageList.length > 0) {
      return;
    }
    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }

    setPageList(
      section.question.map((question) => ({
        ...question,
        isCorrect: false,
        isSubmitted: false,
      }))
    );
    setCurrentIndex(0);
  }, [section]);

  return (
    <CommonPage
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      currentPage={currentPage}
      currentIndex={currentIndex}
      totalNo={pageList.length}
      overlayVisible={overlayVisible}
      isCorrect={currentPage.isCorrect}
      handleSubmit={!currentPage.type.includes("choice") ? handleSubmit : null}
    >
      {currentPage.type.includes("choice") && (
        <ChoiceTestPage
          section={section}
          pageList={pageList}
          currentPage={currentPage}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          setPageList={setPageList}
          setOverlayVisible={setOverlayVisible}
        />
      )}
      {!currentPage.type.includes("choice") && (
        <SubjectiveExamPage
          currentPage={currentPage}
          userInput={userInput}
          setUserInput={setUserInput}
          handleSubmit={handleSubmit}
        />
      )}
    </CommonPage>
  );
};

export default VocaTestPage;
